<template>
  <div class="product">
    <ProductTabs />
    <ProductTabsContent
      :statsCounters="counters"
      :analytics-data="analyticsData"
    />
    <!--    <div class="product__sliders page-container" v-if="(activeTab !== ' ' && activeTab !== 'description' && buyTogether) || accessorise.length">-->
    <!--      <ProductsBuyTogether-->
    <!--        v-if="activeTab !== ' ' && activeTab !== 'description' && buyTogether"-->
    <!--        :data="buyTogether"-->
    <!--        :title="$t('joints')"-->
    <!--        without-container-->
    <!--        class="product__sliders-wrap"-->
    <!--      />-->
    <!--      <div class="product__sliders-wrap" v-if="accessorise.length">-->
    <!--        <CategorySlider :title="$t('accessory_title')" :items="accessorise" without-container />-->
    <!--      </div>-->
    <!--    </div>-->
    <MapModal class="product__map-modal" />
    <CommentsModal />
    <CommentsPhotoModal />
    <PhotoModal />
    <PayPartModal></PayPartModal>
    <price-bottom-bar :analytics-data="analyticsData"/>
    <rendered-blocks
      uid="product_bottom"
      :product-id="productId"
      :product-sku="code"
    />
    <rendered-blocks
      :uid="`product_${productId}_bottom`"
      :product-id="productId"
      :product-sku="code"
    />
    <rendered-blocks
      :uid="`product_cat_${categoryId}_bottom`"
      :product-id="productId"
      :product-sku="code"
    />
  </div>
</template>

<script>
import ProductTabs from './layouts/ProductTabs'
import ProductTabsContent from './layouts/ProductTabsContent'
import { mapActions, mapState, mapGetters } from 'vuex'
import MapModal from '../../components/checkout/delivery/MapModal'
import CommentsModal from '../../components/comments/CommentModal'
import PhotoModal from '../../components/product/product-page/photo-gallery/PhotoModal'
import CommentsPhotoModal from '../../components/comments/CommentPhotoModal'
// import CategorySlider from '../../components/category/CategorySlider'
// import ProductsBuyTogether from '../../components/product/product-block/ProductsBuyTogether'
import { GoogleTagManagerService, EsputnikService, GoogleEnhancedEcommerce } from '@/services/AnalyticService'
import PriceBottomBar from '@/components/product/product-page/PriceBottomBar.vue'
import PayPartModal from '@/components/product/product-page/pay-part/PayPartModal.vue'
import RenderedBlocks from '@/components/rendered-blocks/RenderedBlocks.vue'

export default {
  name: 'Product',
  components: {
    RenderedBlocks,
    PayPartModal,
    PriceBottomBar,
    // ProductsBuyTogether,
    // CategorySlider,
    CommentsPhotoModal,
    PhotoModal,
    CommentsModal,
    MapModal,
    ProductTabs,
    ProductTabsContent
  },
  computed: {
    ...mapGetters(['isShowedSkeletons']),
    ...mapState({
      userDataFromServer: state => state.user.user_data,
      productsInCartIds: state => state.cart.cartSort,
      error: state => state.productInfo.error,
      message: state => state.productInfo.message,
      accessorise: state => state.products.accessories,
      buyTogether: state => state.products.buyTogether,
      viewedProducts: state => state.products.viewedProducts,
      activeTab: state => state.productTabs.activeTab,
      config: state => state.init.config
    }),
    computedCode () {
      if (this.analyticsData.length > 1) {
        return this.analyticsData[0].id
      }
      return this.analyticsData[0].id || this.code
    },
    shortPhotoList () {
      const array = [...this.photos, ...this.videos]
      return array.slice(0, 5)
    },
    photoOffset () {
      return this.photos.length + this.videos.length - this.shortPhotoList.length
    }
  },
  props: {
    availableInCityStores: {
      type: Boolean,
      default: true
    },
    shopMaxOpeningHoursInUserCity: {
      type: String,
      default: ''
    },
    productPanelInfo: {
      type: String
    },
    uid: {
      type: String
    },
    analyticsData: {
      type: Array
    },
    title: {
      type: String
    },
    titleRu: {
      type: String
    },
    code: {
      type: String
    },
    rate: {
      type: String
    },
    rating: {
      type: String
    },
    isPreorder: {
      type: Boolean,
      default: false
    },
    price: {
      type: Number
    },
    oldPrice: {
      type: Number
    },
    productId: {
      type: Number
    },
    mainProductId: {
      type: Number
    },
    commentsCount: {
      type: [String, Number]
    },
    photos: {
      type: Array
    },
    videos: {
      type: Array
    },
    isAwardedBonuses: {
      type: Boolean
    },
    isArchive: {
      type: Boolean
    },
    inStock: {
      type: Boolean
    },
    isNovelty: {
      type: Boolean
    },
    isMonoSet: {
      type: Boolean
    },
    categoryId: {
      type: Number
    },
    categoryParentId: {
      type: Number
    },
    inWishListStatus: {
      type: Boolean
    },
    isInWaitList: {
      type: Boolean
    },
    hasSets: {
      type: Boolean,
      default: false
    },
    hasBadge: {
      type: Boolean,
      default: false
    },
    productBadgeDescription: {
      type: String
    },
    isOnlyOnSite: {
      type: Boolean
    },
    shortCharacteristics: {
      type: Object
    },
    badges: {
      type: Array
    },
    characteristics: {
      type: Array
    },
    equipments: {
      type: Array
    },
    descriptions: {
      type: Array
    },
    instructions: {
      type: Array
    },
    instruction: {
      type: Array
    },
    maxSideLength: {
      type: Boolean
    },
    arrivalDate: {
      type: String
    },
    arrivalDateEmployee: {
      type: String
    },
    options: {
      type: Array
    },
    isDebitingBonuses: {
      type: Boolean
    },
    saleEndTime: {
      type: [Object, Number, String]
    },
    combinedProducts: {
      type: Object
    },
    counters: Array,
    maxAvailableQuantity: [Number, String],
    isSale: Boolean,
    countdownTill: Number,
    countdownEnabled: Boolean,
    availableInStore: [Boolean, Object],
    esputnikData: Object,
    isOutlet: {
      type: Boolean,
      default: false
    },
    totalProductQuantity: [String, Number],
    productQuantityForEndsBadge: [String, Number],
    technicalExpertWorkingHours: {
      type: Object,
      default: () => ({ from: 9, to: 18 }),
      validator: (value) => ['from', 'to'].every(key => key in value)

    },
    pickupFromFmAvailability: {
      type: Boolean,
      default: false
    },
    progressbarTotal: {
      type: Number,
      default: 0
    },
    progressbarCurrent: {
      type: Number,
      default: 0
    }
  },
  methods: {
    ...mapActions([
      'CHANGE_PRODUCT_INFO',
      'FETCH_PRODUCT_WARRANTY',
      'FETCH_360_OVERVIEW',
      'FETCH_SETS_WITH_PRODUCT',
      'GET_BUY_TOGETHER',
      'GET_ACCESSORIES'
    ]),
    ...mapActions('comments', ['FETCH_COMMENTS']),
    ...mapActions('questions', ['FETCH_QUESTIONS', 'FETCH_TAGS'])
  },
  created () {
    // Отправка данных в eSputnik
    EsputnikService.sendProductPageInfo({ product: this.esputnikData })

    // Формируем и записываем данные в localStorage для блока просмотренных товаров
    const viewedItem = {
      analytics_data: this.analyticsData,
      code: this.code,
      id: this.productId,
      category_id: this.categoryId,
      category_parent_id: this.categoryParentId,
      image_url: this.photos[0]?.['origin_photo'] ?? '',
      is_available: this.inStock,
      is_in_wait_list: this.isInWaitList,
      is_in_wish_list: this.inWishListStatus,
      is_novelty: this.isNovelty,
      link: window.location.pathname,
      price: {
        price_new: this.price ?? '',
        price_old: this.oldPrice ?? ''
      },
      rating: this.rating,
      reviews_count: this.commentsCount,
      title: this.title,
      title_ru: this.titleRu,
      characteristics: this.shortCharacteristics ?? {}
    }

    const viewedProducts = JSON.parse(localStorage.getItem('viewedProducts')) ?? []
    const viewedProductsWithoutCurrent = viewedProducts.filter(item => item.code !== this.code)
    const newViewedProducts = [viewedItem, ...viewedProductsWithoutCurrent].slice(0, 20)

    localStorage.setItem('viewedProducts', JSON.stringify(newViewedProducts))
  },
  mounted () {
    // получаем комментарии
    this.FETCH_COMMENTS({
      id: this.productId,
      endpoint: this.$constants.COMMENTS.GET_PRODUCT_COMMENTS_ENDPOINT
    })

    // получаем теги вопросов
    this.FETCH_TAGS({
      endpoint: this.$constants.QUESTIONS.GET_QUESTIONS_TAGS_ENDPOINT
    })
    // получаем вопросы
    this.FETCH_QUESTIONS({
      id: this.productId,
      endpoint: this.$constants.QUESTIONS.GET_PRODUCT_QUESTIONS_ENDPOINT
    })

    // получаем гарантии
    this.FETCH_PRODUCT_WARRANTY(this.productId)
    this.FETCH_360_OVERVIEW(this.productId)

    // получаем блок вместе дешевле
    const idForSetsWithProduct = this.isMonoSet ? this.mainProductId : this.productId
    this.FETCH_SETS_WITH_PRODUCT(idForSetsWithProduct)

    // получаем вместе покупают
    this.GET_BUY_TOGETHER({ productId: this.productId })

    // получаем аксесуары
    this.GET_ACCESSORIES({ productId: this.productId })

    // Если активны счастливые часы, переопределяем бейджи на неакционных товарах
    let computedBadges
    if (this.config?.['happy_hours']?.['is_in_time'] && this.config?.['happy_hours']?.['sale_rate'] && !this.isSale) {
      computedBadges = [{
        name: '-' + this.config.happy_hours.sale_rate + '% 🕓',
        color: '#4e93d9'
      }]
    } else {
      computedBadges = this.badges
    }

    // записываем инфо о продукте из пропсов
    this.CHANGE_PRODUCT_INFO({
      ...this.$props,
      shortPhotoList: this.shortPhotoList,
      photoOffset: this.photoOffset,
      badges: computedBadges
    })

    // удаляем элемент для отступа
    document.querySelector(`.hidden-padding`).remove()

    const tag = document.createElement('script')
    tag.src = 'https://www.youtube.com/iframe_api'
    const firstScriptTag = document.getElementsByTagName('script')[0]
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)

    // передаем информацию о товаре в расширенную электронную торговлю
    let listForAnalytics = sessionStorage.getItem(`listForAnalytics`)

    const categoryId = this.categoryId
    const categoryParentId = this.categoryParentId
    const productNameRu = this.titleRu
    const sku = this.code
    const price = this.price ? this.price.toString() : ''

    if (window.location.href === document.referrer) {
      listForAnalytics = `false`
    }

    if (listForAnalytics !== `false`) {
      GoogleTagManagerService.productInfoEvent({
        analyticsData: [
          {
            'name': productNameRu,
            'id': sku,
            'price': price,
            'category': `${categoryParentId}/${categoryId}`
          }
        ],
        actionField: { 'list': listForAnalytics || `` }
      })
    }

    sessionStorage.setItem(`listForAnalytics`, ``)

    // Генерируем ивент что страница готова
    window.dispatchEvent(new CustomEvent('productPageReady'))
    if (GoogleEnhancedEcommerce.isEnabled) {
      GoogleEnhancedEcommerce.viewItem({
        value: +GoogleEnhancedEcommerce.getGoogleEnhancedEcommerceData(this.analyticsData[0]).price * parseInt(GoogleEnhancedEcommerce.getGoogleEnhancedEcommerceData(this.analyticsData[0]).quantity),
        items: [GoogleEnhancedEcommerce.getGoogleEnhancedEcommerceData(this.analyticsData[0])]
      })
    }
  },
  watch: {
    error (message) {
      if (message) {
        this.$notify({
          group: 'error',
          title: this.$t('error'),
          text: message,
          type: 'error'
        })
      }
    },
    message (message) {
      if (message) {
        this.$notify({
          group: 'success',
          title: '',
          text: message,
          type: 'success'
        })
      }
    }
  }
}
</script>

<style scoped lang="sass">

.product--skeleton
  max-width: 1400px
  padding: 0 15px
  margin: 0 auto

.skeleton-desktop
  display: none
  +mmin($tablet)
    display: block

.skeleton-mobile
  display: block
  +mmin($tablet)
    display: none

.product__sliders
  margin-top: 40px

.product__sliders-wrap
  margin-bottom: 30px

  +mmin($tablet)
    margin-bottom: 60px
</style>
